__turbopack_context__.v({
  "back": "Ufvcfq_back",
  "backIcon": "Ufvcfq_backIcon",
  "backText": "Ufvcfq_backText",
});
